import React from 'react'
import createUploadForm, { createModelSchema } from '../ContentUploadForm'

const mutation = `mutation getCareer($data: CareerApplicationInput, $files: [Upload]) {
  createCareerApplication(uploadRequest:$data, files: $files) {
    email
    createdDate
  }
}`

const schema = createModelSchema()

const textStrings = {
  trackingTitle: 'Careers',
  fileUploadTitle: 'CV & Cover letter',
  fileUploadSubtitle:
    'To apply, please attach your CV and a supporting cover letter',
  submitErrorText:
    'Your career application form didn’t upload properly, please try again.',
  submitButtonText: 'Apply Now',
  submitLoadingSpinner: 'Sending Application',
  submitSuccessText:
    'Thank you for sending your career application form, a member of our team will be in touch.'
}

const ContentUploadForm = createUploadForm(mutation, schema)

const ContentCareersForm = (props) => {
  const applyExtra = () => ({
    career: props.careerId
  })

  return (
    <ContentUploadForm
      {...props}
      {...textStrings}
      applyExtra={applyExtra}
      fieldCount={7}
      f24name="careers-form"
    />
  )
}

export default ContentCareersForm
